

import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import axios from 'axios';
import ArchivedHeader from './ArchivedHeader';
import { HiMailOpen } from 'react-icons/hi';
import { toast } from 'react-toastify';
import DeletePopup from '../DeletePopup';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import services from '../../services';
import TablePagination from '../../common/TablePagination';
import { getLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';


const ArchivedBoard = () => {
    const [allTasks, setAllTasks] = useState([]);
    const [filteredTasks, setFilteredTasks] = useState([]);
    const [selectedBoard, setSelectedBoard] = useState('');
    const [selectedReOpenBoard, setSelectedReOpenBoard] = useState('');
    const [availableBoards, setAvailableBoards] = useState([]);
    const [archivePage, setArchivePage] = useState(1);
    const [archiveTotalPages, setArchiveTotalPages] = useState(1);
    const [boardColumn, setBoardColumn] = useState([]);
    const [modalState, setModalState] = useState({
        isOpen: false,
        action: null,
        item: null,
        title: '',
        description: ''
    });

    const [showArchiveOpen, setShowArchiveOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isArchivedView = location.state?.isformArchivedView || false;
    const boardName = location.state?.boardName || '';

    const fetchArchivedTasks = useCallback(async (boardId, page = 1) => {
        try {
            const params = boardId
                ? { limit: 20, page, boardId }
                : { limit: 5000 };
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/task/archieveTask`, { params });
            const archivedData = response.data.data;

            if (boardId) {
                const boardEntry = Array.isArray(archivedData) ? archivedData[0] : archivedData;
                const tasksForBoard = boardEntry?.tasks || [];
                const boardMeta = availableBoards.find((b) => b.id === boardId);
                const tasksWithBoardName = tasksForBoard.map((task) => ({
                    ...task,
                    boardName: task.boardName || boardEntry?.boardName || boardMeta?.boardName,
                    boardId: task.boardId || boardEntry?.boardId || boardId,
                }));
                setAllTasks(tasksWithBoardName);
                const totalPages = response.data?.pagination?.totalPages
                    || response.data?.totalPages
                    || response.data?.totalPage
                    || 1;
                setArchiveTotalPages(totalPages);
                return;
            }

            if (Array.isArray(archivedData) && archivedData.length > 0) {
                const allTasksData = archivedData.reduce((acc, boardData) => {
                    if (boardData.tasks && boardData.tasks.length > 0) {
                        const tasksWithBoardName = boardData.tasks.map((task) => ({
                            ...task,
                            boardName: boardData.boardName,
                            boardId: boardData.boardId,
                        }));
                        return acc.concat(tasksWithBoardName);
                    }
                    return acc;
                }, []);
                const sortedTasks = allTasksData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                setAllTasks(sortedTasks);
                setArchiveTotalPages(1);
            } else {
                setAllTasks([]);
                setArchiveTotalPages(1);
            }
        } catch (error) {
            console.error('Error fetching archived tasks:', error);
            setAllTasks([]);
        }
    }, [availableBoards]);

    const fetchAllBoards = useCallback(async () => {
        try {
            const userDataRaw = getLocalStorageItem('userData');
            const userData = typeof userDataRaw === 'string' ? JSON.parse(userDataRaw) : userDataRaw;

            let boards = [];
            if (userData?.role === 'User') {
                const response = await services.userassignboard.GET_UserAssignBoard_ID(userData?.id);
                const assignedBoards = response?.data?.data || [];
                boards = assignedBoards
                    .filter((item) => item?.Board)
                    .map((item) => ({ id: item.Board.id, boardName: item.Board.boardName, board: item.Board }));
            } else {
                const { data } = await services.board.GETALLBOARD();
                boards = (data || []).map((board) => ({ id: board.id, boardName: board.boardName, board }));
            }

            setAvailableBoards(boards);
            setSelectedBoard(boards[0]?.boardName || 'All');
        } catch (error) {
            console.error('Error fetching boards:', error);
            setAvailableBoards([]);
            setSelectedBoard('All');
        }
    }, []);

    useEffect(() => {
        fetchAllBoards();
    }, [fetchAllBoards]);

    useEffect(() => {
        if (!selectedBoard) return;

        if (selectedBoard === 'All') {
            fetchArchivedTasks();
        } else {
            const boardMeta = availableBoards.find((b) => b.boardName === selectedBoard);
            if (boardMeta) {
                fetchArchivedTasks(boardMeta.id, archivePage);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBoard, archivePage, availableBoards]);

    useEffect(() => {
        setArchivePage(1);
    }, [selectedBoard]);

    useEffect(() => {
        setFilteredTasks(allTasks);
    }, [allTasks]);

    const handleTaskClick = (task) => {
        navigate(`/detail/${task.id}`, {
            state: {
                selectedMail: task,
                taskID: task.id,
                clickMailTask: true,
                type: task.taskType || 'Gmail',
                openTaskDataSidebar: true,
                currentTask: task,
                boardId: task.boardId,
                isArchived: true,
                isformArchivedView: true,
                boardName: boardName
            },
        });
    };
    const [taskDetails, setTaskDetails] = useState()
    const handleReopenTask = async (task, type, boardObj) => {
        if (!task.boardListId || !task.boardId) {
            toast.error('Cannot reopen task: missing board or column information.');
            return;
        }

        if (type == "isBoardSelected") {
            setModalState({
                isOpen: true,
                action: 'reopen',
                item: { ...task, boardId: selectedReOpenBoard, boardListId: selectedColumn },
                title: 'Are you sure you want to reopen this task?',
                description: `This will move the task back to the board ${boardObj.label}.`
            });
            setShowArchiveOpen(false)
        } else {
            setShowArchiveOpen(true)
            setTaskDetails(task)
        }


    };

    const handleSleepTask = (taskId) => {
        setModalState({
            isOpen: true,
            action: 'sleep',
            item: taskId,
            title: 'Are you sure you want to sleep this task?',

        });
    };

    const confirmAction = async () => {
        const { action, item } = modalState;
        if (action === 'reopen') {
            try {
                const data = {
                    boardListId: item.boardListId,
                    boardId: item.boardId,
                    isInComplete: false,
                };
                await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${item.id}`, data);
                toast.success('Task has been reopened.');
                setAllTasks((prevTasks) => prevTasks.filter((t) => t.id !== item.id));
            } catch (error) {
                console.error('Error reopening task:', error);
                toast.error('Failed to reopen task.');
            }
        } else if (action === 'sleep') {
            try {
                await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/task/deleteTask/${item}`);
                toast.success('Task moved to sleep successfully');
                setAllTasks((prevTasks) => prevTasks.filter((task) => task.id !== item));
            } catch (error) {
                console.error('Error deleting task:', error);
                if (selectedBoard === 'All') {
                    fetchArchivedTasks();
                } else {
                    const boardMeta = availableBoards.find((b) => b.boardName === selectedBoard);
                    fetchArchivedTasks(boardMeta?.id, archivePage);
                }
            }
        }
        closeModal();
    };

    const closeModal = () => {
        setModalState({ isOpen: false, action: null, item: null, title: '', description: '' });
    };

    const handleClose = () => setShowArchiveOpen(false);
    const handleReOpenBoardChange = (e) => {
        const boardId = e.target.value;
        setSelectedReOpenBoard(boardId);

        if (boardId) {
            getBoardColumn(boardId);
        }
    };

    const [selectedColumn, setSelectedColumn] = useState("");

    const handleColumnChange = (e) => {
        setSelectedColumn(e.target.value);

    };

    const getBoardColumn = async (id) => {
        try {
            const response = await services.board.SELECTED_BOARD(id);
            const data = response?.data?.map((item) => ({
                value: item?.id,
                label: item?.coloum,
            }));
            setBoardColumn(data);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <ArchivedHeader
                isArchivedView={isArchivedView}
                selectedBoard={selectedBoard}
                availableBoards={availableBoards}
                onBoardChange={(e) => setSelectedBoard(e.target.value)}
            />
            <div className="flex-grow p-4 overflow-y-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {filteredTasks.length > 0 ? (
                        filteredTasks.map((task) => (
                            <div
                                key={task.id}
                                onClick={() => handleTaskClick(task)}
                                style={{
                                    background: '#f6f9fd',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    border: '1px solid #e3e8ee',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                    fontSize: '14px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    cursor: 'pointer',
                                }}
                            >
                                <div style={{ flexGrow: 1 }}>
                                    <div style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                flexGrow: 1,
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {task?.taskType === 'Gmail' && (
                                                <HiMailOpen style={{ width: '16px', height: '16px', flexShrink: 0 }} />
                                            )}
                                            {task?.taskType === 'Whatsapp' && (
                                                <img
                                                    src="assets/whatsapp.svg"
                                                    alt="whatsapp"
                                                    style={{ width: '16px', height: '16px', flexShrink: 0 }}
                                                />
                                            )}
                                            <div
                                                style={{
                                                    color: '#222',
                                                    fontWeight: 500,
                                                    textAlign: 'start',
                                                    whiteSpace: 'pre-line',
                                                    overflowWrap: 'break-word',
                                                    maxWidth: '100%',
                                                }}
                                            >
                                                {task.title || task.subject || 'Untitled Task'}
                                            </div>
                                        </div>
                                        <span
                                            style={{
                                                color: '#888',
                                                fontSize: '13px',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {moment(task.updatedAt).format('MMM DD')}
                                        </span>
                                    </div>

                                    <div className="text-xs text-gray-500">Board: {task.boardName}</div>


                                    {task.SubTasks && task.SubTasks.length > 0 && (
                                        <div className="mt-2 pt-2 border-t border-gray-200 ml-4">
                                            {task.SubTasks.map((subTask) => (
                                                <div key={subTask.id} className="flex items-center gap-2 mt-1">
                                                    {subTask?.taskType === 'Gmail' ? (
                                                        <HiMailOpen className="w-4 h-4 text-gray-500 flex-shrink-0" />
                                                    ) : subTask?.taskType === 'Whatsapp' ? (
                                                        <img
                                                            src="assets/whatsapp.svg"
                                                            alt="whatsapp"
                                                            className="w-4 h-4 flex-shrink-0"
                                                        />
                                                    ) : null}
                                                    <span className="text-sm text-gray-700">{subTask.title || subTask.subject || 'Untitled Sub-task'}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>


                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '10px',
                                        marginTop: '10px',
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div
                                            title="Sleep"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSleepTask(task.id);
                                            }}
                                            style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
                                                />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M9 8.25h2.25M12.75 8.25H15M9 12h2.25M12.75 12H15m-3.75 3.75h2.25M12.75 15.75H15"
                                                />
                                            </svg>
                                        </div>
                                        <div
                                            data-reopen-button="true"
                                            title="Reopen"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleReopenTask(task);
                                            }}
                                            style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="1.5"
                                                stroke="currentColor"
                                                style={{ pointerEvents: 'none' }}
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    {task.User && (
                                        <div
                                            style={{
                                                width: '28px',
                                                height: '28px',
                                                borderRadius: '50%',
                                                backgroundColor: '#512da8',
                                                color: 'white',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                            }}
                                            title={task.User.name}
                                        >
                                            {task.User.name.charAt(0).toUpperCase()}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="col-span-4 text-center text-gray-500">
                            No archived tickets found for the selected board.
                        </p>
                    )}
                </div>
                {selectedBoard !== 'All' && (
                    <TablePagination
                        currentPage={archivePage}
                        totalPages={archiveTotalPages}
                        onPageChange={setArchivePage}
                    />
                )}
            </div>
            {modalState.isOpen && (
                <DeletePopup
                    open={modalState.isOpen}
                    title={modalState.title}
                    description={modalState.description}
                    onConfirm={confirmAction}
                    onCancel={closeModal}
                />
            )}

            {showArchiveOpen && (
                <>
                    <Modal
                        show={showArchiveOpen}
                        onHide={handleClose}
                        centered
                        backdrop="static"
                        keyboard={false}
                        contentClassName="p-2 rounded-4"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600', color: '#333' }}>
                                Select a Board
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div className="pt-1 pb-4  bg-white ">
                                <select
                                    value={selectedReOpenBoard}
                                    onChange={(e) => handleReOpenBoardChange(e)}
                                    className="archived-board-select p-2 w-full border rounded-md shadow-sm"
                                >
                                    <option value="">Choose Board</option>
                                    {boardName && boardName?.length > 0 && boardName.map((board) => (
                                        <option key={board.value} value={board?.value}>
                                            {board.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="pt-1 pb-4 bg-white border-b">
                                <select
                                    value={selectedColumn}
                                    onChange={handleColumnChange}
                                    className="archived-board-select p-2 w-full border rounded-md shadow-sm"
                                >
                                    <option value="">Choose Column</option>
                                    {boardColumn.map((column) => (
                                        <option key={column.value} value={column.value}>
                                            {column.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </Modal.Body>

                        <Modal.Footer>

                            <div className="bg-white px-1 pb-3 flex gap-2 items-center justify-center sm:px-6">

                                <button
                                    type="button"
                                    className="inline-flex justify-center rounded bg-white px-6 py-2 text-sm font-semibold text-gray-900 shadow-sm border border-gray-300 hover:bg-gray-50 font-google"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={
                                        "inline-flex justify-center rounded bg-[#42B4F4] px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#42B4F4] border-0 font-google"
                                        + ((selectedReOpenBoard && selectedColumn) ? "" : " opacity-60 cursor-not-allowed")
                                    }
                                    onClick={() => {
                                        if (selectedReOpenBoard && selectedColumn) {
                                            const selectedBoardObj = boardName.find(board => board.value === selectedReOpenBoard);
                                            handleReopenTask(taskDetails, "isBoardSelected", selectedBoardObj);
                                        }
                                    }}
                                    disabled={!(selectedReOpenBoard && selectedColumn)}
                                >
                                    Confirm
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
        </div>
    );
};

export default ArchivedBoard;
